<template>
  <div
    class="modal fade createNewModal"
    id="genererRedevanceModal"
    tabindex="-1"
    aria-hidden="true"
    ref="genererRedevanceModalRef"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40" style="position: relative;">
        <!-- Overlay loader -->
        <div v-if="isLoading" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" 
             style="top: 0; left: 0; background-color: rgba(255, 255, 255, 0.9); z-index: 9999; border-radius: 0.375rem;">
          <div class="text-center">
            <!-- <div class="spinner-border text-primary mb-2" role="status" style="width: 3rem; height: 3rem;">
              <span class="visually-hidden">Chargement...</span>
            </div> -->
             <div class="fw-semibold text-dark mb-3">{{ progressMessage }}</div>
            <!-- Barre de progression -->
            <div v-if="showProgress" class="progress mb-2" style="height: 20px; width: 300px;">
              <div 
                class="progress-bar progress-bar-striped progress-bar-animated" 
                role="progressbar" 
                :style="`width: ${progressPercentage}%`"
                :aria-valuenow="progressPercentage" 
                aria-valuemin="0" 
                aria-valuemax="100">
                {{ progressPercentage }}%
              </div>
            </div>
            <div v-if="progressDetails" class="text-muted">
              {{ progressDetails }}
            </div>
          </div>
        </div>
        
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
            <h5 class="modal-title fw-bold text-black">Géneration de redevances</h5>
        </div>
        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
        <Form ref="redevanceForm" @submit="genererRedevances" :validation-schema="redevanceSchema">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Catégorie d'abonné <span class="text-danger">*</span>
                    </label>
                    <Field name="categorieAbonne" v-slot="{ field }">
                        <Multiselect 
                        :options="categorieAbonneOptions"
                        :searchable="true" 
                        v-model="field.value"
                        v-bind="field"
                        placeholder="Sélectionner la catégorie de l'abonné"
                        />
                    </Field>
                    <ErrorMessage name="categorieAbonne" class="text-danger"/>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                        <label class="d-block text-black fw-semibold mb-10">
                            Modèle <span class="text-danger">*</span>
                        </label>
                        <Field name="modeleBoite" v-slot="{ field }">
                            <Multiselect 
                            :options="modeleOptions" 
                            :searchable="true" 
                            v-model="field.value"
                            v-bind="field"
                            />
                        </Field>
                        <ErrorMessage name="modeleBoite" class="text-danger"/>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Commune <span class="text-danger">*</span>
                    </label>
                    <Field name="commune" v-model="communeSelect" v-slot="{ field }">
                        <Multiselect 
                        v-model="field.value" 
                        v-bind="field" 
                        :options="communesOptions" 
                        :searchable="true"
                        @change="communeChange($event)" 
                        placeholder="Rechercher une commune"
                        noResultText="Aucun enregistrement trouvé" 
                        noOptionsText="Tapez au moins caractères caractères" />
                    </Field>
                    <ErrorMessage name="commune" class="text-danger" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Agence <span class="text-danger">*</span>
                    </label>
                    <Field name="bureau" v-model="bureauselect" v-slot="{ field }">
                        <Multiselect 
                        :no-options-text="nooptions" 
                        v-model="field.value" 
                        v-bind="field" 
                        :options="bureauxOptions"
                        placeholder="Selectionner un bureau" />
                    </Field>
                    <ErrorMessage name="bureau" class="text-danger" />
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="d-block text-black fw-semibold mb-10">
                        Année <span class="text-danger">*</span>
                    </label>
                    <Field name="annee" v-slot="{ field }">
                        <Multiselect 
                            :options="years" 
                            :searchable="true" 
                            v-model="field.value"
                            v-bind="field"
                            placeholder="Sélectionner une année"
                        />
                    </Field>
                    <ErrorMessage name="annee" class="text-danger"/>
                    </div>
                </div>
                <div class="col-md-12">
                <div class="d-flex align-items-center ">
                    <button
                    class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                    type="submit"
                    :disabled="isLoading"
                    >
                        <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        {{ isLoading ? 'Génération...' : 'Générer une redevance' }}
                    </button>
                    <button 
                      type="button"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      :disabled="isLoading"
                      class="btn btn-danger transition border-0 lh-1 fw-medium">
                      <i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                      <span class="position-relative"></span>Annuler
                    </button>
                </div>
                </div>
            </div>
        </Form>
        </div>
        <button
            type="button"
            class="btn-close shadow-none"
            data-bs-dismiss="modal"
            aria-label="Close"
            :disabled="isLoading"
        ></button>
      </div>
    </div>
  </div>

 
</template>

<script lang="ts">
import { defineComponent, onMounted, onBeforeUnmount, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import { Option } from "@/models/Option";
import ApiService from '@/services/ApiService';
import { error , hideModal, success, } from '@/utils/utils';
import { EnvoieLotDetail } from '@/models/EnvoieLotDetail';
import Multiselect from '@vueform/multiselect';
import router from '@/router';
import { hide } from '@popperjs/core';
import axios from 'axios';
import JwtService from '@/services/JwtService';
import SocketService from '@/services/SocketService';

export default defineComponent({
  name: "GenererRedevanceModal",
  components: {
  Form,
  Field,
  ErrorMessage,
  Multiselect,
},
setup: (_, { emit }) => {
  const redevanceSchema = Yup.object().shape({
    // categorieAbonne: Yup.number().typeError('Veuillez entrer un nombre').required('La catégorie de l\'abonné est obligatoire'),
    categorieAbonne: Yup.number().typeError('Veuillez entrer un nombre').notRequired(),
    // modeleBoite: Yup.number().typeError('Veuillez entrer un nombre').required('Le modèle est obligatoire'),
    modeleBoite: Yup.number().typeError('Veuillez entrer un nombre').notRequired(),
    annee: Yup.string().required('L\'année est obligatoire'),
    bureau: Yup.number().typeError('Veuillez entrer un nombre').required('La valeur est obligatoire'),
    commune: Yup.number().typeError('Veuillez entrer un nombre').required('La valeur est obligatoire'),
  });

  const redevanceForm = ref<null | EnvoieLotDetail>(null);
  const communesOptions = ref<Array<Option>>([]);
  const bureauxOptions = ref<Array<Option>>([]);
  const communeSelect = ref(null);
  const bureauselect = ref();
  const abonnementOptions = ref([]);
  const categorieAbonneOptions = ref([]);
  const arrondissementOptions = ref([]);
  const selectedArrondissement = ref([]);
  const selectedQuartier = ref([]);
  const modeleOptions = ref([]);
  const genererRedevanceModalRef = ref<null | HTMLElement>(null);
  const isLoading = ref(false);
  const progressPercentage = ref(0);
  const progressMessage = ref('Génération en cours...');
  const progressDetails = ref('');
  const showProgress = ref(false);
  let websocket: WebSocket | null = null;

  const messages = ref<string[]>([]);


  const year = ref(new Date().getFullYear());
  const years = ref(
    Array.from({ length: 1 }, (_, i) => {
        const year = new Date().getFullYear() + 1;
        return { value: year + i, label: year + i };
    })
  );



    const genererRedevances = async (value: any, redevanceForm) => {
        isLoading.value = true;
        value = value as EnvoieLotDetail;
        value.estGenerer = 1;
        console.log("Mes redevances", value);
        
        try {
            // ENREGISTREMENT DES REDEVANCES
            const response = await ApiService.post('/redevances/generer', value);
            const data = response.data;
            console.log("Ma reponse", data);

            // await listenForRedevanceUpdates();

            if (data.code === 201) {
              console.log("Redevance générée avec succès");
            //     value.fichier = data.data.retourg.mergedFileName || '';
            //     const lotResponse = await ApiService.post('/envoie/lot/details', value);
            //     const lotData = lotResponse.data;
                
            //     if (lotData.code === 201) {
                success(data.message);
                emit('close');
                redevanceForm.resetForm();
                isLoading.value = false;
                showProgress.value = false;
                hideModal(genererRedevanceModalRef.value);
            //     }
            
            } else {
            //     // aucune opérations effectuées
                emit('close');
                redevanceForm.resetForm();
                hideModal(genererRedevanceModalRef.value);
                error(data.message);
                isLoading.value = false;
                showProgress.value = false;
            }
        } catch (err : any) {
            hideModal(genererRedevanceModalRef.value);
            error(err.response.data.message);
            isLoading.value = false;
            showProgress.value = false;
        } 
        // finally {
        //     isLoading.value = false;
        // }
    };



    const fetchCommune = async () => {
      ApiService.get('/communes')
        .then(async ({ data }) => {
          const donneee = data.data.data;
          communesOptions.value = donneee.map((commune: any) => {
            return {
              label: commune.libelle,
              value: commune.id,
            };
          });
          if (JwtService.getUserCheckIfAllAgence() !== "true") {
            const element: any = await fetchAgences1(JwtService.getUserAgence());
            communeSelect.value = element.communeId;
            bureauselect.value = element.id;
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }

    function communeChange(value) {
      if (value) {
        bureauxOptions.value = [];
        arrondissementOptions.value = [];
        selectedArrondissement.value = [];
        selectedQuartier.value = [];
        bureauselect.value = "";
        ApiService.get('/bureaux/commune/' + value)
          .then(({ data }) => {
            const donnee = data.data;
            if (donnee.length > 0) {
              bureauxOptions.value = donnee.map((bureau: any) => {
                return {
                  label: bureau.nom,
                  value: bureau.id,
                };
              });
            }
          })
          .catch(({ response }) => {
            //
          });
        ApiService.get('/communes/arrondissements/' + value)
          .then(({ data }) => {
            const donnee = data.data;
            if (donnee.length > 0) {
              arrondissementOptions.value = donnee.map((arrondissement: any) => {
                return {
                  label: arrondissement.libelle,
                  value: arrondissement.id,
                };
              });
            }
          })
          .catch(({ response }) => {
            //error(response.data.message);
          });
      } else {
        arrondissementOptions.value = [];
        selectedArrondissement.value = [];
        selectedQuartier.value = [];
        bureauselect.value = "";
      }
    }

    const fetchAgences = async (key) => {
      try {
        const response = await axios.get('/bureaus/recherche/' + key);
        const bureauxData = response.data.data;
        bureauxOptions.value = bureauxData.map((bureau) => ({
          value: bureau.id,
          label: bureau.nom,
        }));
        return bureauxOptions.value;
      } catch (error) {
        //
      }
    };

    const fetchCategorieAbonnes = async () => {
        return ApiService.get('/categorieAbonnes')
        .then(({ data }) => {
        if (data.code === 200) {
            // abonnements.value = data.data;
            categorieAbonneOptions.value = data.data.data.map((categorieAbonne: any) => ({
            value: categorieAbonne.id,
            label: categorieAbonne.code+' [ '+categorieAbonne.libelle+' ] ',
            }));
        }
        })
        .catch((response) => {
          error(response.data.message);
        });
    };

    const fetchModeles = async () => {
      ApiService.get("/modele_boites")
      .then(({ data }) => {
        const donnees = data.data;
        modeleOptions.value = donnees.map((modele) => {
          return {
            value: modele.id,
            label: modele.code+" [ "+modele.libelle+" ]",
          }
        });
      })
      .catch(({ response }) => {
        error(response.data.message)
      });
    }

    const fetchAgences1 = async (key) => {
      try {
        const response = await axios.get(`/bureaus/${parseInt(key)}`);
        const bureau = response.data.data;
        let data = [
          {
            value: bureau.id,
            label: bureau.nom,
          }
        ];
        bureauxOptions.value = data;
        return { id: bureau.id, communeId: bureau.commune.id };
      } catch (error) {
        //
      }
    };


    onMounted( async () => {

      await fetchCommune();
      await fetchCategorieAbonnes();
      await fetchModeles();

      listenForRedevanceUpdates();

    });


    // onBeforeUnmount(() => {
      // Nettoyer les écouteurs Socket.IO
      // SocketService.off('welcome');
      // SocketService.off('test_response');
      // SocketService.off('RedevanceProgress');
    // });


    //######## SOCKET WEBSOCKET ########//

    // Écouter les événements WebSocket liés à la génération de redevance
    const listenForRedevanceUpdates = () => {
      console.log("Bon je suis là");
      SocketService.on("redevance_progress", (data) => {
        console.log("Données reçues du serveur WebSocket:", data);
        if (data) {
          // progress.value = Math.round((data.facturesGenerees / data.totalFactures) * 100);
          // progressNiveau.value = `${data.facturesGenerees} sur ${data.totalFactures}`;
          // message.value = data.message;
          progressPercentage.value = data.percentage || 0;
          progressMessage.value = data.message || 'Traitement en cours...';
          progressDetails.value = data.details || '';
          showProgress.value = true;
          console.log("Redevance mise à jour:", data);
          // success("La redevance a été générée avec succès.");

          // Si la génération est terminée
          // if (data.completed || data.percentage >= 100) {
            // isLoading.value = false;
            // showProgress.value = false;
            
            // if (data.success !== false) {
            //   // success("La redevance a été générée avec succès..");
            //   // emit('close');
            //   // redevanceForm.resetForm(); // Si vous avez accès
            //   hideModal(genererRedevanceModalRef.value);
            // } else {
            //   error(data.error || "Erreur lors de la génération");
            // }
          // }
        }
      });
    };

  return { 
      redevanceSchema, 
      redevanceForm,
      categorieAbonneOptions, 
      modeleOptions, 
      bureauxOptions,
      communesOptions,
      years, 
      genererRedevanceModalRef,
      fetchAgences,
      genererRedevances,
      communeSelect,
      bureauselect,
      communeChange,
      isLoading,
      nooptions: "Aucun enregistrement trouvé",
      progressPercentage,
      progressMessage,
      progressDetails,
      showProgress,
      messages,
    };
},
});
</script>

<style src="@vueform/multiselect/themes/default.css"></style>